import {
  FunctionComponent,
  memo,
  SyntheticEvent,
  useEffect,
  useState,
} from 'react';
import { useYaMetrica } from '~frontend/provider/yametrica';
import { useTranslation } from 'react-i18next';
import { Case } from '~types';

import { useGameCount, useStatusGame, useSuperPrizeMode } from '../hooks';
import ButtonsCase, { OpenCase } from './ButtonsCase';
import { useProfile } from '../../profile/hooks';

import { Link } from 'react-router-dom';
import _ from 'lodash';
import { AuthBlock } from '~frontend/components/AuthBlock';
import { FreeCaseV2Timer } from '../FreeCaseV2Timer';
import dayjs from 'dayjs';
import Currency from '~frontend/components/Currency';
import { useConfig } from '~frontend/components/hooks';
import FormatDate from '~frontend/components/home/cases/FormatDate';

interface IPlayButtonm {
  getCase: Case;
  onFastEndBtnClick?: any;
}

const PlayButton: FunctionComponent<IPlayButtonm> = memo(
  ({ getCase, onFastEndBtnClick }) => {
    const yametrica = useYaMetrica();
    const getProfile = useProfile();
    const [gameStatus] = useStatusGame();
    const [countOpen, setGameCount] = useGameCount();
    // const [caseBonusPrice, setCaseBonusPrice] = useState(0);
    // const [isSuperPrizeGame] = useSuperPrizeMode();
    const getConfig = useConfig();

    const reachGoal = (
      event: SyntheticEvent<HTMLElement>,
      { reachgoal } = event?.currentTarget?.dataset ||
        // eslint-disable-next-line no-unsafe-optional-chaining
        (event.target as HTMLElement)?.dataset,
    ) => {
      yametrica.reachGoal(reachgoal);
    };

    // const casePrice = getCase.price / 100;
    // const isBlogger = getProfile?.group === 4 ? true : false;
    // const bonusFormula = getConfig.caseBonusPrizeFormula?.props.find(
    //   (item) => casePrice > item.minCasePrice && casePrice < item.maxCasePrice,
    // );

    // const superGameFactor = isBlogger
    //   ? bonusFormula.bloggerCaseCostFactor
    //   : bonusFormula.caseCostFactor;

    // console.log('superGameFactor', superGameFactor);

    // useEffect(() => {
    //   setCaseBonusPrice(0);
    //   const newCaseBonusPrice = isSuperPrizeGame
    //     ? casePrice + casePrice * superGameFactor
    //     : 0;

    //   console.log('newCaseBonusPrice', newCaseBonusPrice);
    //   setCaseBonusPrice(newCaseBonusPrice);
    // }, [isSuperPrizeGame, casePrice, superGameFactor, countOpen]);

    const { t } = useTranslation();

    return !getProfile ? (
      <div className="case_actions">
        <div className="case_actions_balance">
          {getCase?.type === 3 && !getProfile && gameStatus === 0 ? (
            <>
              {t('You can open this case')} {t('as soon as you enter the site')}
              ! <br />{' '}
            </>
          ) : (
            <>
              {/* {t('Free and Farm cases')} {t('cheap skins')}{' '}
              {t('sell automatically')} */}
            </>
          )}
          {getCase?.type !== 3 && (
            <>
              {t('Not_enough_to_open_case')}{' '}
              <span>
                {(getCase?.price * countOpen) / 100} <Currency />
              </span>
            </>
          )}
        </div>
        <ButtonsCase />
        {/* <AuthBlock />
      <div className="btn-demo-wrap">
        <OpenCase
          className={`btn-demo b-violet b-violet-blue demover-1 ${
            gameStatus && 'disabled'
          }`}
          data-type="demo"
          data-rar={getCase?.color}
        >
          {t('advantages-sign-in-play-demo')}
        </OpenCase>
        <div className="btns-shadow-2"></div>
      </div> */}
      </div>
    ) : !getCase?.isAccess ? (
      <div className="case-btns-wrap">
        <Link
          to="/pay"
          className="btn btn-sell btn-unlock"
          state={{ promoCode: _.get(_.first(getCase?.getPromoCodes), 'items') }}
        >
          <span className="text">{t('Unlock')}</span>
        </Link>
      </div>
    ) : getCase?.type === 7 &&
      getCase?.userFreeOpen < 1 &&
      getCase?.freeCaseV2minDeposit <= getProfile.deposit24Hour &&
      getProfile?.deposit24HourTtl > 0 ? (
      <div className="case-btns-wrap">
        <a className="btn btn-blue disabled" href="#">
          <FreeCaseV2Timer
            deposit24HourTtl={dayjs()
              .add(getProfile?.deposit24HourTtl, 'milliseconds')
              .format()}
          />
        </a>
      </div>
    ) : getCase?.type === 7 && getCase?.userFreeOpen < 1 ? (
      <div className="case-btns-wrap">
        <Link to="/pay" className="btn btn-sell btn-unlock">
          <span className="text">{t('Unlock')}</span>
        </Link>
      </div>
    ) : (
      <>
        <div
          className="case_actions"
          style={{ display: `${gameStatus === 4 ? 'none' : 'flex'}` }}
        >
          {getProfile?.money < getCase?.price * countOpen &&
            getCase?.type !== 3 && (
              <div className="case_actions_balance">
                {t('Not_enough_to_open_case')}{' '}
                <span>
                  {(getCase?.price * countOpen - getProfile?.money) / 100}{' '}
                  <Currency />
                </span>
              </div>
            )}
          {(getCase?.type === 3 || getCase?.type === 4) &&
            gameStatus === 0 &&
            getProfile && (
              <div className="case_actions_balance">
                <>
                  {getCase?.getDateEnd && (
                    <FormatDate getCase={getCase} className="" />
                  )}
                  {t('Free and Farm cases')} {t('cheap skins')}{' '}
                  {t('sell automatically')}
                </>
              </div>
            )}
          <ButtonsCase onFastEndBtnClick={onFastEndBtnClick} />
          {/* {[1, 2, 3].includes(gameStatus) && (
        <div className="case-btns-wrap">
          <ButtonsCase />
        </div>
      )} */}
        </div>
      </>
    );
  },
);

export { PlayButton };
